/** The isolated test sandbox has no outbound identity-provider access. */
export const socialAuthAvailable = !(
  process.env.NEXT_PUBLIC_TEST === "true" &&
  process.env.NEXT_PUBLIC_DISABLE_THIRD_PARTY === "true"
);

export function requestFacebookLogin(
  onToken: (token: string) => void,
  onError: () => void
) {
  const fb = typeof window !== "undefined" && window.FB;
  if (!socialAuthAvailable || !fb?.login) {
    onError();
    return;
  }
  let settled = false;
  const timer = window.setTimeout(() => {
    if (!settled) {
      settled = true;
      onError();
    }
  }, 20000);
  const finish = (response: any) => {
    if (settled) return;
    settled = true;
    window.clearTimeout(timer);
    if (response?.status === "connected" && response.authResponse?.accessToken)
      onToken(response.authResponse.accessToken);
    else onError();
  };
  try {
    fb.login(finish, { scope: "gaming_profile" });
  } catch {
    finish(null);
  }
}
